import * as React from 'react';

import { InventoryMovementStatus } from '@rematter/frontend-lib-api-client';
import { Button, Menu } from '@rematter/ui-web';
import { LucideMoreHorizontal, LucidePackage } from 'lucide-react';

import { useTranslations } from '../../i18n/useTranslations';

type MovementActionMenuProps = {
  movementId: string;
  status: InventoryMovementStatus;
  facilityId: string;
  onAllocateToLot: (movementId: string, facilityId: string) => void;
};

export const MovementActionMenu = ({
  movementId,
  status,
  facilityId,
  onAllocateToLot,
}: MovementActionMenuProps) => {
  const t = useTranslations();

  const canAllocate = status === 'Completed';

  const menuItems = React.useMemo(
    () => [
      {
        key: 'allocateToLot',
        label: t.movementHistoryView.actions.allocateToLot,
        icon: <LucidePackage className="size-4" />,
        onAction: () => onAllocateToLot(movementId, facilityId),
        isDisabled: !canAllocate,
      },
    ],
    [movementId, facilityId, canAllocate, onAllocateToLot, t],
  );

  return (
    <div className="@MovementActionMenu flex justify-center">
      <Menu
        trigger={
          <Button
            size="icon"
            icon={<LucideMoreHorizontal />}
            variant="outline"
          />
        }
        items={menuItems}
      />
    </div>
  );
};
